import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showEveryoneOption", "shareAudience"];
import React from 'react';
import FormField from 'components/FormField';
import RadioButtonOption from 'components/RadioButtonOption';
import Stack from 'components/Stack';
import { useTranslation } from 'react-i18next';
function ShareAudienceField(_ref) {
  var _ref$showEveryoneOpti = _ref.showEveryoneOption,
    showEveryoneOption = _ref$showEveryoneOpti === void 0 ? true : _ref$showEveryoneOpti,
    shareAudience = _ref.shareAudience,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: t('share_recipients'),
    as: "fieldset"
  }, otherProps), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, showEveryoneOption && /*#__PURE__*/React.createElement(RadioButtonOption, {
    id: "all",
    label: t('state_everyone_in_audience'),
    checked: shareAudience.value === 'all',
    value: "all",
    onChange: function onChange() {
      return shareAudience.set('all');
    }
  }), /*#__PURE__*/React.createElement(RadioButtonOption, {
    id: "changed",
    label: t('state_people_with_changed_status'),
    checked: shareAudience.value === 'changed',
    value: "changed",
    onChange: function onChange() {
      return shareAudience.set('changed');
    }
  })));
}
export default ShareAudienceField;